import { ROUTES } from '@/router/routeNames'

export default [
  {
    name: ROUTES.DASHBOARD_INDEX,
    path: '',
    beforeEnter: async (to, from, next) => {
      const router = useRouter()
      router.push({
        name: ROUTES.DASHBOARD,
        params: { teamPid: to.params.teamPid }
      })
      next()
    }
  },
  {
    name: ROUTES.DASHBOARD,
    path: 'dashboard',
    component: () => import('./pages/DashboardIndex.vue'),
    meta: {
      title: 'Dashboard',
      rightyPrompts: [
        {
          label: 'Weekly insights',
          drawerLabel: 'Summarize my key metrics this week',
          prompt: 'Give me a summary of my key metrics and insights this week. What\'s working well and what needs attention?'
        },
        {
          label: 'Improvement ideas',
          drawerLabel: 'What should I focus on improving?',
          prompt: 'Based on my data, what are the top 3 things I should focus on to improve my results?'
        },
        {
          label: 'Spot anomalies',
          drawerLabel: 'Identify any unusual patterns or drops',
          prompt: 'Look at my recent metrics and identify any unusual patterns, drops, or spikes that need attention. Is anything outside normal ranges?'
        },
        {
          label: 'Top performers',
          drawerLabel: 'Show me my top performers',
          prompt: 'Which campaigns, offers, and segments are performing best right now? Highlight the winners and why they\'re succeeding.'
        }
      ]
    }
  },
]
